module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.1-100.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.1.md
// module id = 517
// module chunks = 311